import React, { Component } from 'react';
import { Parallax } from 'react-scroll-parallax';

import './Separator.css';

class Separator extends Component {

  render() {
    return (
      <div className={this.props.topSeparator && this.props.topSeparator === true ? "top-separator" : "bottom-separator"}>
        <Parallax className="separators" y={this.props.topSeparator && this.props.topSeparator === true ? [15, -20] : [30, -5]} >
          <div className="middle-line"></div>
        </Parallax>
        <Parallax className="separators" y={this.props.topSeparator && this.props.topSeparator === true ? [0, -10] : [10, 0]} >
          <div className="top-line"></div>
        </Parallax>
      </div>
      );
  }
}

export default Separator;
